import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';

@Injectable()
export class ApiLoginProvider {

	constructor(
		private apiProvider: ApiProvider
	) {

	}


	login(data:
		{
			myusername : string,
			mypassword : string,
			mobile : boolean,
			device_uuid : string,

		}
	) {
		return this.apiProvider.post('login',data);
	}

}



// WEBPACK FOOTER //
// ./src/providers/api-login/api-login.ts